export enum AvailableQuestionnairesStatusEnum {
  Loading = 'LOADING',
  FormsAvailable = 'FORMS_AVAILABLE',
  NoFormsAvailable = 'NO_FORMS_AVAILABLE',
}